module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('info-box', {
    attrs: {
      "color-class": "bg-aqua dash-boxx",
      "icon-classes": ['fa', 'fa-users'],
      "text": "Total Users",
      "number": this.dashboardWidgetDetails.users
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('info-box', {
    attrs: {
      "color-class": "bg-aqua dash-boxx",
      "icon-classes": ['fa', 'fa-product-hunt'],
      "text": "Products",
      "number": this.dashboardWidgetDetails.products
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('info-box', {
    attrs: {
      "color-class": "bg-aqua dash-boxx",
      "icon-classes": ['fa', 'fa-video-camera'],
      "text": "Videos",
      "number": this.dashboardWidgetDetails.videos
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('info-box', {
    attrs: {
      "color-class": "bg-aqua dash-boxx",
      "icon-classes": ['fa', 'fa-file-pdf-o'],
      "text": "Documents",
      "number": this.dashboardWidgetDetails.documents
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('info-box', {
    attrs: {
      "color-class": "bg-aqua dash-boxx",
      "icon-classes": ['fa', 'fa-mobile'],
      "text": "Active Mobile Users",
      "number": this.dashboardWidgetDetails.mobile_users
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('info-box', {
    attrs: {
      "color-class": "bg-aqua dash-boxx",
      "icon-classes": ['fa', 'fa-globe'],
      "text": "Active Web Users",
      "number": this.liveUsers
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title pull-right"
  }, [_c('button', {
    staticClass: "btn primary-btn-my",
    attrs: {
      "type": "button",
      "alt": "To access Google Analytics"
    },
    on: {
      "click": function($event) {
        return _vm.logInGoogle()
      }
    }
  }, [_vm._v("Authenticate with Google")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('md-card', [_c('md-card-header', [_vm._v("Live geographic location")]), _vm._v(" "), _c('md-card-content', [_c('table', {
    staticClass: "table table-dark"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Number of Users")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.liveCountryVisitors.rows), function(country) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(country[0]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(country[1]))])])
  }), 0)])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('md-card', [_c('md-card-header', [_vm._v("Type of content been viewed")]), _vm._v(" "), _c('md-card-content', [_c('table', {
    staticClass: "table table-dark"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Path")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Content been viewed")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.liveContentVisitors.rows), function(content) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(content[0]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(content[1]))])])
  }), 0)])])], 1)], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0256f224"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/admin/Dashboard.vue
// module id = 2060
// module chunks = 1